// Copyright (c) Bentley Systems
export class MatchCodeParameter {
  public name: string | undefined;
  public nameType: string | undefined;
  public value: string | undefined;
  public valueType: string | undefined;

  constructor(initializer?: any) {
    if (initializer.name) {this.name = initializer.name;}
    if (initializer.nameType) {this.nameType = initializer.nameType;}
    if (initializer.value) {this.value = initializer.value;}
    if (initializer.valueType) {this.valueType = initializer.valueType;}
  }
}
